import {
  getObject,
  getLeoDate,
  LeoDate,
} from "@surya-digital/leo-ts-types";
import { ProjectName, ProjectNameDTO } from "./projectName";

export interface ProjectDetailsDTO {
  projectName: ProjectNameDTO;
  startDate: string;
  endDate: string;
}

export class ProjectDetails {
  readonly isProjectDetailsProjectDetails: boolean = true;

  readonly projectName: ProjectName;
  readonly startDate: LeoDate;
  readonly endDate: LeoDate;


  constructor(
  projectName: ProjectName, 
  startDate: LeoDate, 
  endDate: LeoDate
  ) {
    this.projectName = projectName;
    this.startDate = startDate;
    this.endDate = endDate;
  }

  static fromDTO(dto: ProjectDetailsDTO): ProjectDetails {
    const projectName = ProjectName.fromDTO(getObject(dto, "projectName", InvalidProjectDetailsProjectNameError));
    const startDate = getLeoDate(dto, "startDate", InvalidProjectDetailsStartDateError);
    const endDate = getLeoDate(dto, "endDate", InvalidProjectDetailsEndDateError);
    return new ProjectDetails(
      projectName,
      startDate,
      endDate
    );
  }

  toDTO(): ProjectDetailsDTO {
    const dto: ProjectDetailsDTO = {
        projectName: this.projectName.toDTO(),
        startDate: this.startDate.toDTO(),
        endDate: this.endDate.toDTO()
    };
    return dto;
  }
  }

ProjectDetails.prototype.toString = function toString(): string {
  return `ProjectDetails(projectName='${this.projectName}',startDate='${this.startDate}',endDate='${this.endDate}')`;
};

export class InvalidProjectDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectDetailsError";
  }
}
export class InvalidProjectDetailsProjectNameError extends InvalidProjectDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectDetailsProjectNameError";
  }
}

export class InvalidProjectDetailsStartDateError extends InvalidProjectDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectDetailsStartDateError";
  }
}

export class InvalidProjectDetailsEndDateError extends InvalidProjectDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectDetailsEndDateError";
  }
}
